/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonArticleVariants
 */
export interface JsonArticleVariants {
    /**
     * 
     * @type {boolean}
     * @memberof JsonArticleVariants
     */
    isExtra?: boolean;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof JsonArticleVariants
     */
    sizes?: { [key: string]: Array<string>; };
}

export function JsonArticleVariantsFromJSON(json: any): JsonArticleVariants {
    return JsonArticleVariantsFromJSONTyped(json, false);
}

export function JsonArticleVariantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonArticleVariants {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isExtra': !exists(json, 'isExtra') ? undefined : json['isExtra'],
        'sizes': !exists(json, 'sizes') ? undefined : json['sizes'],
    };
}

export function JsonArticleVariantsToJSON(value?: JsonArticleVariants | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isExtra': value.isExtra,
        'sizes': value.sizes,
    };
}

